// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names */
import mapperAxaInsuranceOffers from "./mapperAxaInsuranceOffers"
import type {
  AncillariesPassengerOffersInput,
  AncillariesPassengerOffers,
} from "../../../scenes/BookingAncillary/consts/types"

export default function (ancillaries: AncillariesPassengerOffersInput): AncillariesPassengerOffers {
  return {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    axa: ancillaries.axa_insurance && mapperAxaInsuranceOffers(ancillaries.axa_insurance),
  }
}
